<template>
  <footer class="global-footer">
    <span class="global-footer__copyright"
      >&copy; 2021 Sony Music Entertainment. All rights reserved.</span
    >

    <ul class="footer-nav" :class="{ 'footer-nav--active': showMenu }">
      <li class="footer-nav__item">
        <a
          href="https://www.sonymusic.com/privacy-policy/"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
          >Privacy Policy</a
        >
      </li>
      <li class="footer-nav__item">
        <a
          href="https://www.sonymusic.com/terms-and-conditions/"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
          >Terms &amp; Conditions</a
        >
      </li>
      <li class="footer-nav__item">
        <a
          href="https://www.sonymusic.com/feedback/"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
          >Send Us Feedback</a
        >
      </li>
      <li class="footer-nav__item">
        <a
          href="https://www.sonymusic.com/ccpa-contact-form/"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
          >Do Not Sell My Personal Data</a
        >
      </li>
      <li class="footer-nav__item">
        <a
          href="https://www.sonymusic.com/privacy-policy/#your-california-privacy-rights"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
        >
          Your California Privacy Rights
        </a>
      </li>
      <li class="footer-nav__item">
        <a
          href="http://whymusicmatters.com/"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
          >Why Music Matters</a
        >
      </li>
      <li class="footer-nav__item">
        <a
          href="https://www.sonymusic.com/how-we-use-your-data/"
          rel="noreferrer noopener"
          target="_blank"
          class="footer-nav__link"
          >How we use your data</a
        >
      </li>
    </ul>

    <span
      class="global-footer__toggle"
      :class="{ 'global-footer__toggle--active': showMenu }"
      @click="showMenu = !showMenu"
      :aria-label="!showMenu ? 'Open Menu' : 'Close Menu'"
      role="button"
    ></span>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      showMenu: false,
    };
  },
};
</script>
